<div class="modal fade" id="modalDelete" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" id="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
            Delete {{modalName}}
          </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-text">
            Are you sure you want to delete the {{modalName}} 
            <span style="font-weight: bold;">{{title}}</span><br/>
            This action cannot be undone.
        </div>
      </div>
      <div class="modal-footer">
        <button class="modal-btn-delete" type="button" (click)="onDelete()">
          <span *ngIf="!loading">Delete</span>
          <div *ngIf="loading" style="position: relative;">
              <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff" type="ball-clip-rotate"
                [fullScreen]="false"></ngx-spinner>
            </div>
      </button> 
      </div>
    </div>
  </div>